import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
interface FAQ {
  question: string;
  answer: string;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs: FAQ[] = [{
    question: '¿Qué pasa si el libro no cumple mis expectativas?',
    answer: 'Tienes una garantía de satisfacción. Si después de leerlo sientes que no te aportó claridad o que no era lo que buscabas, puedes solicitar un reembolso completo dentro del plazo indicado. No necesitas justificarlo: tu tranquilidad es prioridad.'
  }, {
    question: '¿Este libro sustituye la terapia?',
    answer: 'No. Este libro te ayuda a tomar decisiones emocionales con claridad, pero no reemplaza la atención profesional cuando es necesaria.'
  }, {
    question: '¿Cómo recibo los bonos?',
    answer: 'Después de tu compra recibes un correo con acceso inmediato. No necesitas esperar envíos físicos.'
  }, {
    question: '¿Qué formato tiene el libro y los bonos?',
    answer: 'Todo es digital: PDF y audiolibro. Puedes consumirlo desde tu móvil, tablet o computadora.'
  }, {
    question: '¿Puedo regalarlo a alguien?',
    answer: 'Sí. Puedes usar tu compra como regalo para otra persona. Es una sorpresa transformadora.'
  }, {
    question: '¿Por cuánto tiempo estará disponible la oferta?',
    answer: 'Solo por tiempo limitado. La página avisará cuando el precio cambie.'
  }, {
    question: '¿Necesito saber algo de tarot para aprovechar este libro?',
    answer: 'No. El libro está diseñado para personas sin experiencia previa. No te enseña a "adivinar", sino a usar el tarot como una herramienta mental para entenderte mejor, tomar decisiones sin miedo y expresar lo que necesitas.'
  }, {
    question: '¿Qué pasa si me cuesta concentrarme o leer mucho?',
    answer: 'Por eso incluimos el audiolibro oficial. Puedes escucharlo mientras manejas, caminas o haces ejercicio. La claridad no depende de cuánto lees, sino de cómo integras lo que descubres sobre ti.'
  }];
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 px-4 bg-[#0C0A09] border-t border-[#3b3330]" data-id="element-32">
      <div className="max-w-4xl mx-auto" data-id="element-33">
        {/* Title */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="text-center mb-12" data-id="element-34">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-[#F7F5F2] mb-4" data-id="element-35">
            Preguntas frecuentes
          </h2>
        </motion.div>

        {/* FAQ Accordion */}
        <div className="space-y-4" data-id="element-36">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.1,
          ease: [0.22, 1, 0.36, 1]
        }} className="border border-[#CFA86A]/20 rounded-lg overflow-hidden" style={{
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
        }} data-id="element-37">
              {/* Question */}
              <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 flex items-center justify-between text-left bg-[#0C0A09] hover:bg-[#0C0A09]/80 transition-colors duration-300" data-id="element-38">
                <span className="text-lg font-semibold text-[#CFA86A] pr-4" data-id="element-39">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 45 : 0
            }} transition={{
              duration: 0.3,
              ease: [0.22, 1, 0.36, 1]
            }} className="flex-shrink-0" data-id="element-40">
                  <Plus className="w-6 h-6 text-[#CFA86A]" data-id="element-41" />
                </motion.div>
              </button>

              {/* Answer */}
              <AnimatePresence data-id="element-42">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: [0.22, 1, 0.36, 1]
            }} className="overflow-hidden" data-id="element-43">
                    <div className="px-6 pb-5 pt-2 bg-[#0C0A09] border-t border-[#CFA86A]/10" data-id="element-44">
                      <p className="text-[#F7F5F2]/80 leading-relaxed" data-id="element-45">
                        {faq.answer}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}